// Global save-status store driving the "saving / saved / failed" indicator.

let status = 'idle';       // 'idle' | 'saving' | 'saved' | 'error'
let pending = 0;           // in-flight saves in the current session
let errored = false;       // did any save in this session fail?
let savingStartedAt = 0;   // when the current "saving" session began
let flipTimer = null;

// The server can save faster than the eye can read
const MIN_SAVING_MS = 3000;
const listeners = new Set();
const emit = () => listeners.forEach(fn => fn(status));
const setStatus = (s) => { if (s !== status) { status = s; emit(); } };

export const getSaveStatus = () => status;

export const subscribeSaveStatus = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};

export const trackSave = (promise) => {
    if (status !== 'saving') {          // start a fresh saving session
        errored = false;
        savingStartedAt = Date.now();
        clearTimeout(flipTimer);
        setStatus('saving');
    }
    pending += 1;

    const settle = (isError) => {
        pending -= 1;
        if (isError) errored = true;
        if (pending > 0) return;        // wait for the whole batch

        clearTimeout(flipTimer);
        if (errored) {
            setStatus('error');         // surface failures right away
            return;
        }
        // Success: keep "Saving..." up for the minimum duration before flipping to saved
        const remaining = MIN_SAVING_MS - (Date.now() - savingStartedAt);
        if (remaining <= 0) {
            setStatus('saved');
        } else {
            flipTimer = setTimeout(() => {
                if (pending === 0) setStatus('saved');   // still idle after the wait
            }, remaining);
        }
    };

    return promise.then(
        (res) => { settle(false); return res; },
        (err) => { settle(true); throw err; }
    );
};
